module.exports = __webpack_public_path__ + "static/media/buisness-banking-f8dca509.05ce221a.png";